module.exports = __webpack_public_path__ + "static/media/aliceblue-slider.d05b417a.png";